import { jwtDecode } from 'jwt-decode';
import { getCurrentAuth } from '../http-server';

const parentCommonDetails = () => {
  const auth: any = getCurrentAuth();
  if (auth.parent_accessToken && auth.parent_refreshToken) {
    const decodedToken: any = jwtDecode(auth.parent_accessToken);
    return decodedToken;
  } else {
    return null;
  }
};
export default parentCommonDetails;
